<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-stepper class="col-12 ma-0 pa-0" v-model="index">
      <v-stepper-header>
        <v-stepper-step :complete="index > 1" step="1">Client</v-stepper-step>
        <v-divider></v-divider>
        <!-- <v-stepper-step :complete="index > 2" step="2"
          >Payment Method</v-stepper-step
        >
        <v-divider></v-divider> -->
        <v-stepper-step :complete="index > 3" step="3">Contract</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="index > 4" step="4"
          >Transaction</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="5">Listing</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <client-index
            :showMessage="showMessage"
            :client_id="client_id"
            :setClientData="setClientData"
            :changeModel="changeModel"
          ></client-index>
        </v-stepper-content>
        <!-- <v-stepper-content step="2">
          <payment-index
            :client_name="client_name"
            :client_email="client_email"
            :showMessage="showMessage"
            :client_id="client_id"
            :changeModel="changeModel"
          ></payment-index>
        </v-stepper-content> -->
        <v-stepper-content step="3">
          <contract-index
            :showMessage="showMessage"
            :client_id="client_id"
            :contract_id="contract_id"
            :setContractId="setContractId"
            :changeModel="changeModel"
          ></contract-index>
        </v-stepper-content>
        <v-stepper-content step="4">
          <transaction-index
            :showMessage="showMessage"
            :client_id="client_id"
            :changeModel="changeModel"
          ></transaction-index>
        </v-stepper-content>
        <v-stepper-content step="5">
          <listing-index
            :client_id="client_id"
            :changeModel="changeModel"
            :index="index"
          ></listing-index>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-snackbar
      rounded
      absolute
      right
      bottom
      :color="snackbarColor"
      v-model="snackbar"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import ClientIndex from './client/ClientIndex'
import ContractIndex from './contract/ContractIndex'
import TransactionIndex from './transaction/TransactionIndex'
import ListingIndex from './listing/ListingIndex'
// import PaymentIndex from './payment/PaymentIndex'
export default {
  components: {
    ClientIndex,
    ContractIndex,
    TransactionIndex,
    ListingIndex
    // PaymentIndex
  },
  data() {
    return {
      index: 1,
      client_id: null,
      client_name: null,
      client_email: null,
      contract_id: null,
      snackbarColor: 'default',
      snackbarText: 'Something went wrong',
      snackbar: false
    }
  },
  methods: {
    changeModel(index) {
      this.index = index
    },
    setClientData(id, name, email) {
      this.client_id = id
      this.client_name = name
      this.client_email = email
    },
    setContractId(id) {
      if (id) {
        this.showMessage('contract selected with id ' + id, 'success')
      }
      this.contract_id = id
    },
    showMessage(text, color) {
      this.snackbar = true
      this.snackbarColor = color
      this.snackbarText = text
    }
  }
}
</script>

<style scoped></style>
